export const useKeyUp = (func, keysCode = ['Enter']) => {
	return {
		onKeyUp: (event) => {
			event.stopPropagation();
			keysCode.includes(event.code) && func(event);
		},
	};
};
